import { useEffect, useState } from "react";

import cn from "classnames";
import Icon from "../../components/Icon";
import styles from "./Front.module.sass";
import Loader from "../../components/Loader";
import cusHomePage from "../../i11/CustomizeHomePage";
import BrandBoxFooter from "./Components/footer";
import BrandBoxNavbar from "./Components/navbar";
import CustomizeNftProducts from "./Components/NftProducts";

import { UseApi } from "../../hooks/use-api";
import { useUser } from "../../context";
import { ToastEmitter } from "../../Services/assets/toast-emitter";
import { GetBrand, UpdateBrand } from "../../Services/lib/brand";

const ComMarketPlace = () => {
	const { locale } = useUser();

	const [comMarketVals, setVals] = useState({ title: "", description: "" });
	const [saveButton, setSaveButton] = useState();

	const [{ data: brandData, isLoading }, fetchBrand] = UseApi({
		service: GetBrand,
	});
	const [{ isLoading: titleUpLoading }, updateBrand] = UseApi({
		service: UpdateBrand,
		successMsg: "Success",
	});
	const handlerHomeText = (name, v) => {
		setSaveButton(true);
		setVals((val) => {
			return {
				...val,
				[name]: v.target.value,
			};
		});
	};

	const init = async () => {
		const res = await fetchBrand();

		if (res && res.paragraphs) {
			const {
				paragraphs: { marketplace },
			} = res;
			if (marketplace) {
				setVals(marketplace);
			}
		}
	};

	const updateTitleDesc = async () => {
		if (!comMarketVals.title.trim() || !comMarketVals.description.trim()) {
			ToastEmitter({
				msg: comMarketVals.title ? "Description empty!" : "Title empty!",
				type: "info",
			});
			return;
		}
		const result = await updateBrand({
			paragraphs: {
				...brandData?.paragraphs,
				marketplace: comMarketVals,
			},
		});
		if (result) {
			setSaveButton(false);
		}
	};
	useEffect(() => {
		init();
	}, []);

	return (
		<div className={styles.web}>
			<BrandBoxNavbar image={brandData?.image} name="com-marketplace" />
			<div className={styles.center}>
				<div className={styles.homeToMar}>
					{cusHomePage[locale].home.toUpperCase() + " > "}
					{cusHomePage[locale].com_marketplace.toUpperCase()}
				</div>
				{isLoading ? (
					<Loader className={cn(styles.mrAuto20)} />
				) : (
					<div className={cn(styles.homeTitle)}>
						<input
							defaultValue={comMarketVals.title || ""}
							type="text"
							placeholder={cusHomePage[locale].place_market_title}
							onChange={(v) => handlerHomeText("title", v)}
						/>
						<textarea
							name="Description"
							placeholder={cusHomePage[locale].place_market_desc}
							defaultValue={comMarketVals.description || ""}
							onChange={(v) => handlerHomeText("description", v)}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									e.preventDefault();
								}
							}}
						/>
						{saveButton && (
							<button
								className={cn(
									"button-stroke button-small",
									styles.button,
									styles.mrAuto
								)}
								onClick={updateTitleDesc}
								style={{ marginRight: "auto" }}
							>
								{titleUpLoading && <Loader />}
								{cusHomePage[locale].save}
							</button>
						)}
						<div className={styles.bottomDesc}>
							{cusHomePage[locale].customize_text}
						</div>
					</div>
				)}
			</div>
			<div className={styles.inputSearch}>
				<div style={{ display: "flex" }}>
					{["Collection", "Category", "Type", "Edition"].map((val) => (
						<p>
							{val}
							<Icon name="arrow-down" />
						</p>
					))}
					<p style={{ justifyContent: "start", gap: "10px" }}>
						<Icon name="search" fill="#E3E8EF" />
						Keyboard
					</p>
				</div>
			</div>
			<CustomizeNftProducts />
			<BrandBoxFooter />
		</div>
	);
};

export default ComMarketPlace;
